export default __webpack_public_path__ + "assets/armenia-flag.png";